export default __webpack_public_path__ + "static/media/TFA--AI-0001.51c47299.jpg";